<template>
  <div class="tab-container">
    <div
      class="tab-item"
      :style="chooseTab === tab.value && tabBg[tab.value]"
      v-for="tab in tabList"
      :key="tab.value"
      @click="tabChange(tab)"
    >
      {{ tab.name }}
    </div>

    <!-- <span v-show="abnormal_list.length > 0 && chooseTab =='maxpoint'">
        <el-select v-model="customRegionCtrl" placeholder="请选择" size="small" style="width: 120px" >
          <el-option
            v-for="item in abnormal_list"
            :key='item.id'
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>

      </span> -->
  </div>
</template>

<script>
const tabBg = {
  real: {
    background: "url(images/wz_tab_real_bg.png)",
    backgroundSize: "100% 100%",
    backgroundRepeat: "no-repeat",
    textAlign: "left",
    textIndent: "2vh"
  },
  alarm: {
    background: "url(images/wz_tab_alarm_bg.png)",
    backgroundSize: "100% 100%",
    backgroundRepeat: "no-repeat",
    textAlign: "center"
  }
};

import { mapState } from "vuex";

export default {
  name: "tab",
  props: {
    tabList: Array
  },
  computed: {
    ...mapState(["curData", "abnormal_list", "mapMode"]),
    customRegionCtrl: {
      get() {
        return this.abnormal_list;
      },
      set(v) {
        this.$store.commit("setAbnormalList", v);
      }
    }
  },
  data() {
    return {
      tabBg,
      chooseTab: ""
    };
  },
  mounted() {
    this.chooseTab = this.tabList[0].value;
    this.$emit("onChange", this.chooseTab);
  },
  watch: {
    tabList() {
      this.tabChange(this.tabList[0]);
    },
    mapMode() {
      if (this.mapMode === "alarm") {
      } else {
        this.tabChange({ value: "real" });
      }
    }
  },
  methods: {
    tabChange(v) {
      this.chooseTab = v.value;
      this.$emit("onChange", this.chooseTab);
    }
  }
};
</script>

<style lang="less">
.tab-container {
  width: 100%;
  height: 4.17vh;
  font-size: 4.17vh;
}

.tab-item {
  float: left;
  width: 9.04vw;
  height: 4.17vh;
  cursor: pointer;
  // padding: 0.52vw 1.068vh 0.52vw;
  font-family: "PingFangSC-Medium,PingFang SC";
  font-size: 1.85vh;
  color: white;
}
</style>
